import HoneycombComponent from '@wix/thunderbolt-elements/src/components/Honeycomb/viewer/Honeycomb';
import HoneycombController from '@wix/thunderbolt-elements/src/components/Honeycomb/viewer/Honeycomb.controller';


const Honeycomb = {
  component: HoneycombComponent,
  controller: HoneycombController
};


export const components = {
  ['Honeycomb']: Honeycomb
};

